import { convertToTimeZone, convertToLocalTime } from 'date-fns-timezone';
import { appTimeZone } from './locale';
import { formatDate } from './lib';
/**
 * Convert given date to timezone
 * @private
 * @param {Date|string|number} date
 * @param {string} timeZone
 */

var convertDate = function convertDate(date, timeZone) {
  return timeZone ? convertToTimeZone(date, {
    timeZone: timeZone
  }) : convertToTimeZone(date, {
    timeZone: appTimeZone
  });
};
/**
 * Converts given date time to timezone and returns date in given format
 * @param {Date|string|number} date
 * @param {string} timeZone
 * @param {string} format
 */


export var getZoneDate = function getZoneDate(date, timeZone, format) {
  return formatDate(convertDate(date, timeZone), format || 'DD/MM/YYYY');
};
/**
 * Converts given date time to timezone and returns time in given format
 * @param {Date|string|number} date
 * @param {string} timeZone
 * @param {string} format
 */

export var getZoneTime = function getZoneTime(date, timeZone, format) {
  return formatDate(convertDate(date, timeZone), format || 'hh:mm a');
};
/**
 * Convert given date to timezone
 * @param {Date|string|number} date
 * @param {string} timeZone
 */

export var convertLocalTimeToTimeZone = function convertLocalTimeToTimeZone(date, timeZone) {
  return convertDate(date, timeZone);
};
/**
 * Convert given timezone to locale
 * @param {Date|string|number} date
 * @param {string} timeZone
 */

export var convertTimeZoneToLocalTime = function convertTimeZoneToLocalTime(date, timeZone) {
  return convertToLocalTime(date, {
    timeZone: timeZone
  });
};
export * from 'date-fns';
export { listTimeZones } from 'timezone-support';
export * from './lib';